import { Localized } from "@fluent/react"
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Alert, Typography } from "@mui/material"
import { useState } from "react";
import { TextField } from "@mui/material";
import { useAppDispatch } from "../../../app/hooks";
import { BlockButton } from "../../../app/components/BlockButton";
import { CancelButton } from "../../../app/components/CancelButton";
import { AppUser, blockAppUser } from "../administration";
import { showSuccess } from "../../notifications/notificationsSlice";

export interface BlockUserDialogProps {
    email: string;
    onSuccessfullySaved: (updated: any) => void;
    onCancel: () => void
}

export const BlockUserDialog = ({ email, onSuccessfullySaved, onCancel }: BlockUserDialogProps) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState<boolean>(false);
    const [lockReason, setLockReason] = useState<string>("");
    const [serverError, setServerError] = useState("");

    const handleSubmitClick = async () => {
        try {
            setLoading(true)
            const result = await dispatch(blockAppUser({ email, lockreason: lockReason }));
            if(blockAppUser.fulfilled.match(result)) {
                result.payload as AppUser;
                dispatch(showSuccess("saved"))
                onSuccessfullySaved({ status: "LOCKED", lockedAt: result.payload.lockedAt, lockedBy: result.payload.lockedBy, lockReason: result.payload.lockReason });
            } else {
                let errorMsg = "error"
                if (result.payload) {
                    if (result.payload.kind === 'http') {
                        const problem = result.payload.problem
                        if (problem) {
                            errorMsg = problem.title
                        }
                    }
                }
                setServerError(errorMsg)
            }
        } catch (error) {
            setServerError("error");
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Localized id="user-block-dialog-title">
                    <span>_Zablokuj użytkownika</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Alert
                        severity="info"
                        variant="outlined"
                        sx={{
                            mb: 2,
                            mt: 2,
                            alignItems: "flex-start",
                            "& .MuiAlert-message": {
                                width: "100%",
                            },
                        }}
                    >
                        <Typography variant="body2">
                            <Localized id="user-block-dialog-alert">
                                <span>_Treść alertu</span>
                            </Localized>
                        </Typography>
                    </Alert>

                    <TextField
                        fullWidth
                        value={lockReason}
                        required
                        onChange={(e) => setLockReason(e.target.value)}
                        type={"text"}
                        multiline
                        rows={4}
                        inputProps={{ maxLength: 1000 }}
                        label={<Localized id="user-lock-reason">Powód blokady</Localized>}
                    />
                </DialogContentText>

                {serverError && (
                    <Alert sx={{ marginTop: 1 }} severity="error">
                        <Localized id={serverError}>
                            <span style={{ whiteSpace: 'pre-line' }}>{serverError}</span>
                        </Localized>
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <BlockButton
                    loading={loading}
                    onClick={handleSubmitClick}
                />
                <CancelButton
                    loading={loading}
                    onClick={onCancel}
                />
            </DialogActions>
        </>
    )
}